export default {"src":"/_next/static/media/pair-5.6baf63de.svg","height":402,"width":522,"blurWidth":0,"blurHeight":0};